import { render, staticRenderFns } from "./asset-details.vue?vue&type=template&id=7894b51e"
import script from "./asset-details.vue?vue&type=script&lang=js"
export * from "./asset-details.vue?vue&type=script&lang=js"
import style0 from "./asset-details.vue?vue&type=style&index=0&id=7894b51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports